import api from "../lib/api";

export const getAdminDashboardData = async () => {
  const [orders, products, stats] = await Promise.all([
    api.get("/admin/orders"),
    api.get("/admin/products"),
    api.get("/admin/stats"),
  ]);
  return {
    orders: orders.data,
    products: products.data,
    stats: stats.data,
  };
};

export const listDeliveryPartners = async () => {
  const { data } = await api.get("/admin/delivery-partners");
  return data;
};

export const createDeliveryPartner = async (payload) => {
  const { data } = await api.post("/admin/delivery-partners", payload);
  return data;
};

export const updateDeliveryPartner = async (id, payload) => {
  const { data } = await api.put(`/admin/delivery-partners/${id}`, payload);
  return data;
};

export const deleteDeliveryPartner = async (id) => {
  const { data } = await api.delete(`/admin/delivery-partners/${id}`);
  return data;
};

export const listCustomDesignRequests = async () => {
  const { data } = await api.get("/admin/custom-design");
  return data;
};

export const updateCustomDesignStatus = async (id, status) => {
  const form = new FormData();
  form.append("status", status);
  const { data } = await api.patch(`/admin/custom-design/${id}`, form);
  return data;
};

export const updateOrderStatus = async (id, status, reason = "") => {
  const { data } = await api.patch(`/admin/orders/${id}`, { status, reason });
  return data;
};

export const retryQikinkOrder = async (id) => {
  const { data } = await api.post(`/admin/orders/${id}/qikink/retry`);
  return data;
};

export const syncQikinkProducts = async () => {
  const { data } = await api.post("/admin/qikink/sync-products");
  return data;
};

export const trackNimbusPostShipment = async (id) => {
  const { data } = await api.get(`/shipping/track/${id}`);
  return data;
};

export const createNimbusPostShipment = async (id) => {
  const { data } = await api.post(`/shipping/create/${id}`);
  return data;
};

export const cancelNimbusPostShipment = async (id) => {
  const { data } = await api.post(`/shipping/cancel/${id}`);
  return data;
};

export const importProductsCsv = async (file, preview = false) => {
  const form = new FormData();
  form.append("file", file);
  const { data } = await api.post(`/admin/products/import-csv?preview=${preview ? "true" : "false"}`, form);
  return data;
};

export const createProduct = async (payload) => {
  const { data } = await api.post("/admin/products", payload);
  return data;
};

export const updateProduct = async (id, payload) => {
  const { data } = await api.put(`/admin/products/${id}`, payload);
  return data;
};

export const deleteProduct = async (id) => {
  const { data } = await api.delete(`/admin/products/${id}`);
  return data;
};
